{
	"language": {
		"aria": "Byt språk"
	},
	"placeholder": {
		"title": "Ditt kandidatcenter är på väg",
		"body": "Det finns inget här ännu. Vi skickar dig en länk via e-post så snart det är klart."
	},
	"not_found": {
		"title": "Sidan kunde inte hittas",
		"body": "Kontrollera länken du följde, eller använd länken från din e-post."
	},
	"error_boundary": {
		"reload": "Ladda om sidan"
	},
	"login": {
		"loading": "Laddar…",
		"title": "Logga in på ditt kandidatcenter",
		"intro": "Ange din e-postadress för att se dina ansökningar.",
		"email_label": "E-postadress",
		"email_placeholder": "du@exempel.com",
		"submit": "Logga in",
		"sending": "Skickar…",
		"sent": {
			"title": "Kolla din e-post",
			"body": "Om {{email}} matchar en ansökan är en inloggningslänk på väg.",
			"retry": "Fick du den inte? Kontrollera adressen och försök igen"
		},
		"resent": {
			"title": "Vi har skickat en ny inloggningslänk till dig",
			"body": "Länken du öppnade har gått ut. Om din e-postadress matchar en ansökan är en ny inloggningslänk på väg. Den öppnar samma sida.",
			"request_manually": "Fick du den inte? Begär en ny länk"
		},
		"request_error": {
			"throttled": "För många försök. Vänta en minut och försök igen.",
			"invalid_email": "Ange en giltig e-postadress.",
			"generic": "Något gick fel. Försök igen."
		},
		"unknown_organisation": {
			"title": "Sidan kunde inte hittas",
			"body": "Kontrollera länken du följde, eller använd länken från din e-post."
		},
		"error": {
			"title": "Något gick fel",
			"body": "Vi kunde inte ladda den här sidan. Försök igen om en stund."
		}
	},
	"organisations": {
		"title": "Dina ansökningar",
		"intro": "Välj ett företag för att se ansökningarna du har skickat till dem.",
		"count_one": "{{count}} ansökan",
		"count_other": "{{count}} ansökningar",
		"empty": {
			"title": "Inga ansökningar ännu",
			"body": "När du ansöker till ett företag visas det här."
		},
		"error": "Vi kunde inte ladda dina företag. Försök igen om en stund.",
		"log_out": "Logga ut",
		"logging_out": "Loggar ut…"
	},
	"submissions": {
		"title": "Tidigare ansökningar",
		"back_to_organisations": "Alla företag",
		"cv_uploaded": "CV uppladdat",
		"empty": {
			"title": "Inga ansökningar ännu",
			"body": "Ansökningar du skickar till {{organisation}} visas här."
		},
		"error": "Vi kunde inte ladda dina ansökningar. Försök igen om en stund.",
		"log_out": "Logga ut",
		"logging_out": "Loggar ut…"
	},
	"profile": {
		"link": {
			"title": "Din profil",
			"cv_added": "CV tillagt",
			"cv_missing": "Inget CV ännu"
		},
		"back": "Tillbaka till ansökan",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Du går med på att bli kontaktad om det här jobbet.",
		"cv": {
			"title": "CV",
			"upload": {
				"title": "Ladda upp ditt CV",
				"drop_hint": "eller dra och släpp det här",
				"constraints": "{{types}}, högst {{size}} MB",
				"uploading": "Laddar upp {{fileName}}…",
				"done": "CV uppladdat",
				"error_type": "Den här filtypen stöds inte. Tillåtna typer: {{types}}.",
				"error_size": "Filen är för stor. Maxstorleken är {{size}} MB."
			},
			"remove": {
				"label": "Ta bort {{fileName}}",
				"question": "Ta bort {{fileName}}?",
				"consequence": "Arbetsgivaren kommer inte längre att kunna se den. Det går inte att ångra.",
				"confirm": "Ta bort CV",
				"cancel": "Avbryt",
				"removing": "Tar bort…",
				"error": "Det gick inte att ta bort ditt CV. Försök igen."
			}
		},
		"work_history": {
			"title": "Arbetslivserfarenhet",
			"description": "Berätta för oss om relevant arbetslivserfarenhet: var du har jobbat, vad du gjorde där och hur länge du jobbade där. Du kan lägga till mer än ett jobb om de är relevanta.",
			"placeholder": "Beskriv ett jobb du har haft",
			"input_label": "Jobbdetaljer",
			"save": "Spara",
			"saving": "Sparar…",
			"cancel": "Avbryt",
			"edit": "Redigera",
			"remove": "Ta bort",
			"add_another": "Lägg till ett jobb till",
			"error_empty": "Skriv något innan du sparar.",
			"error_limit": "Du kan lägga till upp till {{max}} jobb.",
			"unsaved_changes": "Du har osparade ändringar i din arbetslivserfarenhet. Vill du lämna sidan ändå och förlora dem?",
			"hints": {
				"label": "Detaljer om det här jobbet",
				"included": "nämnt",
				"missing": "inte nämnt ännu"
			}
		},
		"education": {
			"title": "Utbildning",
			"description": "Berätta för oss om relevant utbildning: vad du har studerat, var och när. Examina, skolor, kurser och certifikat räknas. Du kan lägga till mer än en.",
			"placeholder": "Beskriv en examen, skola eller kurs",
			"input_label": "Utbildningsdetaljer",
			"save": "Spara",
			"saving": "Sparar…",
			"cancel": "Avbryt",
			"edit": "Redigera",
			"remove": "Ta bort",
			"add_another": "Lägg till en utbildning till",
			"error_empty": "Skriv något innan du sparar.",
			"error_limit": "Du kan lägga till upp till {{max}} utbildningar.",
			"unsaved_changes": "Du har osparade ändringar i din utbildning. Vill du lämna sidan ändå och förlora dem?"
		},
		"licenses": {
			"title": "Behörigheter och certifikat",
			"description": "Berätta om behörigheter och certifikat du har, till exempel körkort, truckkort eller hygienbevis. Ange när du fick det och när det går ut, om det gör det. Du kan lägga till mer än ett.",
			"placeholder": "Beskriv en behörighet eller ett certifikat",
			"input_label": "Behörighetsdetaljer",
			"save": "Spara",
			"saving": "Sparar…",
			"cancel": "Avbryt",
			"edit": "Redigera",
			"remove": "Ta bort",
			"add_another": "Lägg till en behörighet till",
			"error_empty": "Skriv något innan du sparar.",
			"error_limit": "Du kan lägga till upp till {{max}} behörigheter.",
			"unsaved_changes": "Du har osparade ändringar i dina behörigheter. Vill du lämna sidan ändå och förlora dem?"
		}
	},
	"submission": {
		"back": "Tillbaka till mina ansökningar",
		"back_short": "Tillbaka",
		"not_found": {
			"title": "Ansökan kunde inte hittas",
			"body": "Den här ansökan finns inte, eller så är den inte din."
		},
		"result": {
			"heading": "Bekräftelseskärmen du såg efter att du ansökt"
		},
		"summary": {
			"title": "Sammanfattning av dina svar",
			"submitted_on": "Du skickade in det här formuläret den",
			"submitted_more_than_once": "Du fyllde i det här formuläret mer än en gång. Vi slår automatiskt samman din profil; ansökan nedan är den senaste."
		}
	}
}
